var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditPencil = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6806 6.86517L17.1351 0.319651C16.7091 -0.106225 16.0185 -0.106225 15.5925 0.319651L0.31964 15.5925C0.115038 15.7971 6.17869e-05 16.0745 0 16.3638V22.9093C0 23.5118 0.488421 24.0002 1.09092 24.0002H7.63644C7.92574 24.0002 8.20318 23.8852 8.40772 23.6806L23.6806 8.40773C24.1065 7.98173 24.1065 7.29117 23.6806 6.86517ZM7.18503 21.8184H2.18207V16.8154L13.0913 5.90623L18.0942 10.9092L7.18503 21.8184ZM14.6334 4.36369L19.6364 9.36665L21.3666 7.63645L16.3636 2.63349L14.6334 4.36369Z",
    fill: "#0B0B28"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditPencil);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editPencil.6c6ddf88558a14d18ffab950c073e41f.svg";